import React from 'react';
import { Paper, Text, Group } from '@mantine/core';
interface StatsWidgetProps {
  title: string;
  value: number;
  subtitle: string;
  icon: React.ReactNode;
  color: string;
  progress?: number;
  onClick?: () => void;
}
export function StatsWidget({
  title,
  value,
  subtitle,
  icon,
  color,
  progress = 75,
  onClick
}: StatsWidgetProps) {
  return <Paper radius="lg" p="md" withBorder className={`h-full ${onClick ? 'cursor-pointer hover:shadow-md transition-shadow' : ''}`} onClick={onClick} data-id="element-145">
      <Group align="flex-start" gap="md" data-id="element-146">
        <div className="flex items-center justify-center rounded-full flex-shrink-0" style={{
        backgroundColor: color,
        width: '48px',
        height: '48px',
        color: 'white'
      }} data-id="element-147">
          {icon}
        </div>
        <div className="flex-1" data-id="element-148">
          <Text c="dimmed" size="sm" tt="uppercase" fw={500} className="mb-1" data-id="element-149">
            {title}
          </Text>
          <Text fw={700} size="xl" className="mb-1" data-id="element-150">
            {value.toLocaleString()}
          </Text>
          <Text size="sm" c="dimmed" data-id="element-151">
            {subtitle}
          </Text>
        </div>
      </Group>
    </Paper>;
}